var state = {
    cognitoInfo: {},
    loggedIn: false,
    loadingState: true,
    errorLoadingState: false
  }
  
  function setLoggedIn(newValue) {
    state.session.loggedIn = newValue;
  }
  
  function setLoggedOut() {
    state.session.loggedIn = false;
    state.cognitoInfo = {};
  }
  
  function setCognitoInfo(newValue){
    state.cognitoInfo = newValue;
  }
  
  export default {
    state: state,
    setLoggedIn: setLoggedIn,
    setLoggedOut: setLoggedOut,
    setCognitoInfo: setCognitoInfo
  }


// WEBPACK FOOTER //
// ./src/app/user-info-store.js